import { getCmsProperty as n } from "@sunrise/shared";
import { defineComponent as o } from "vue";
import r from "./index139.js";
const p = o({
  name: "E_Mobile_Ad",
  components: {
    MsAdPlace: r
  },
  props: {
    cmsContent: {
      type: Object,
      required: !0
    },
    isInDisturber: Boolean
  },
  setup(e) {
    function t() {
      return n("meinestadt/advertising/types#dfpPlacementIdMobile", e.cmsContent, "");
    }
    return {
      getPlacementId: t
    };
  }
});
export {
  p as default
};
